import {isProduction} from './common';
import {Platform} from 'react-native';

export * from './common';
export const vapidKey =
  'BIigTwrZYZeT_zceo2AaYz77jWf4twslaFA4Xr154Zdhf9W99wQd56I5AtSey3iDCJB9wEqCxcXO1pm2zPRTX58';
export const MARKETING_URL = Platform.select({
  web: isProduction ? 'https://amana.app' : 'https://amana.amanadev.com',
});
